import { PageWithLayout } from './_app';
import Main, { makeTitle } from '@/components/layouts/Main';
import Head from 'next/head';
import BoxFull from '@/components/box/BoxFull';

type AboutProps = {};

const FAQ_QUESTIONS = [
  {
    q:
      "I'm a Infosec/Hacking tool developer, how do I join the Porchetta Industries platform and receive funding for my tool(s)?",
    a:
      'Right now Porchetta Industries is an invite-only platform as we have no idea if this business model can work and is sustainable. As we grow, we will be sending out invites to developers that have met a certain level of quality and popularity in the Infosec/Hacking community with their tools and we deem to warrant funding through our platform.\n' +
      '\n' +
      'Additionally, a balance between the number of developers funded on our platform and\n' +
      'subscribers has to always be taken into consideration in order to make it worth while for the individual developers who join us.\n' +
      '\n' +
      'If we do see this business model working, further down the road we intend to make a\n' +
      'public portal where developers can submit their tool for review in order to join our platform. We currently have no ETA on this.\n' +
      '\n' +
      'We recommend subscribing to our mailing list and joining our official Discord server to keep up-to-date on the latest news in regards to invites, status of the public submission portal & new tools added to the platform.\n' +
      '\n',
  },
  {
    q:
      'I run a publicly available Linux distribution. Can I subscribe to gain access to the exclusive updates and package them in my distro?\n',
    a:
      "It's against our Terms of Service to do so without our explicit permission. Please contact us directly and it may be possible to work something out.\n",
  },
  {
    q: "I'm an individual not a company/organization. Can I still subscribe?\n",
    a:
      "You technically could but Porchetta Industries is meant for companies/organizations. However, as an individual , if you submit a meaningful Pull Request (that gets merged) to any of our tool's public repositories, you will receive lifetime access to that tool's exclusive updates, content and perks ❤️",
  },
];

const About: PageWithLayout<AboutProps> = ({}) => {
  return (
    <>
      <Head>
        <title>{makeTitle('Frequently Asked Questions')}</title>
      </Head>
      <BoxFull
        className="max-w-4xl"
        type={`happy`}
        title={`Frequently Asked Questions`}
        mainTitle={`F.A.Q.`}>
        {FAQ_QUESTIONS.map(({ q, a }) => (
          <div className="mb-10 text-porchetta-white">
            <p>
              <strong>{q}</strong>
            </p>
            <div>
              {a.split('\n').map((line) => (
                <p className="mt-3">{line}</p>
              ))}
            </div>
          </div>
        ))}
      </BoxFull>
    </>
  );
};

About.Layout = Main;

export default About;
